<div class="content-group">
  <p>{{ 'loginForm.noAccount.label' | cxTranslate }}
    <a
      [routerLink]="{ cxRoute: 'register' } | cxUrl"
      class="btn btn-link"
    >{{ 'loginForm.noAccount.link' | cxTranslate }}</a>
  </p>
</div>
